import { styled, css } from "@mui/material";

interface BlurBoxProps {
  width: string;
  height: string;
  top: string;
  left: string;
}

export const BlurBox = styled("div", {
  shouldForwardProp: prop =>
    !["width", "height", "top", "left"].find(x => x !== prop),
})<BlurBoxProps>(
  ({ theme, width, height, top, left }) => css`
    position: absolute;
    filter: blur(100px);
    background-color: ${theme.background.blurBox};
    width: ${width};
    height: ${height};
    top: ${top};
    left: ${left};
  `,
);

export const BackgroundContainer = styled("div")(
  ({ theme }) => css`
    display: flex;
    justify-content: center;

    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: -10;

    ${theme.breakpoints.up("mobile")} {
      padding: 8px;
    }

    ${theme.breakpoints.up("tablet")} {
      padding: 12px;
    }

    ${theme.breakpoints.up("desktop")} {
      padding: 24px;
    }
  `,
);

export const ImageContainer = styled("div")(
  ({ theme }) => css`
    overflow-x: hidden;
    border-radius: 32px;

    .background-desktop-xl {
      display: none;
      ${theme.breakpoints.up("desktopXl")} {
        display: block;
      }
    }

    .background-desktop {
      display: none;
      ${theme.breakpoints.between("desktop", "desktopXl")} {
        display: block;
      }
    }

    .background-tablet {
      display: none;
      ${theme.breakpoints.between("tablet", "desktop")} {
        display: block;
      }
    }

    .background-mobile {
      display: none;
      ${theme.breakpoints.between("mobile", "tablet")} {
        display: block;
      }
    }
  `,
);
